module.exports = __webpack_public_path__ + "static/media/undraw_business_deal.eadf2808.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_business_deal.svg
// module id = 13
// module chunks = 0